const initialFilterState = {
  search: '',
  group: null
}

export default {
  namespaced: true,
  state: {
    filter: {...initialFilterState},
    pagination: {
      offset: 0,
      limit: 12
    },
  },
  mutations: {
    setFilter(state, value) {
      state.filter = value
      state.pagination.offset = 0
    },
    setPagination(state, value) {
      state.pagination = value
    },
    resetFilter(state) {
      state.filter = initialFilterState;
    }
  },
  actions: {
    setPagination({commit}, value) {
      return commit('setPagination', value);
    },
    setFilterSearch({commit, state}, search) {
      return commit('setFilter', {...state.filter, search});
    },
    setFilterGroup({commit, state}, group) {
      return commit('setFilter', {...state.filter, group});
    },
    resetFilter({commit}) {
      return commit('resetFilter');
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/colorsModule.js